import initializeApp from 'wps-vue/src/app';

// Je kunt configuratie-opties doorgeven
initializeApp({
    appName: 'WPS Application',
    progressColor: '#1E40AF'
});